import FuseAnimate from '@fuse/core/FuseAnimate'
import React, { useEffect, useRef, useState } from 'react'
import { FormControl, Stack, TextField, Typography } from '@mui/material';
import Select from 'react-select';
import customStyles from 'app/shared-components/SelectCustomStyle';

export default function SearchHoliday(props) {
    const formRef = useRef(null);
    const [years, setYears] = useState('')
    const {countryOptions, selectedCountry, changeHandler, changeYear, selectedYear} = props;
    useEffect(() => {
        let currentYears = new Date().getFullYear() + 1
        let allYears = [];
        for(let i = 0; i<10; i++) {
            allYears.push({
                label: currentYears,
                value: currentYears
            })
            currentYears -= 1;
        }
        setYears(allYears)
        changeYear(allYears[1])
    }, [])
    

    return (
        <FuseAnimate delay={500}>
            <div className="flex container">
                <FormControl
                    ref={formRef}
                    className="flex flex-row"
                    sx={{ ml: '24px' }}>
                        <div className="mr-16">
                          {!!countryOptions.length &&  <Select name="country"
                                placeholder="Select Country"
                                value={selectedCountry}
                                onChange={changeHandler}
                                className="select countryStyle"
                                classNamePrefix="select"
                                options={countryOptions}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                                styles={customStyles()}
                            />}
                            
                        </div>
                        <div>
                            <Select name="year"
                                placeholder="Select Year"
                                value={selectedYear}
                                className="select yearStyle"
                                classNamePrefix="select"
                                onChange={changeYear}
                                options={years}
                                // menuIsOpen={!!years.length}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                                styles={customStyles()}
                            />
                        </div>
                </FormControl>
            </div>
        </FuseAnimate>
    )
}
